module.exports = __webpack_public_path__ + "static/media/twitter-green.a6c39211.png";